export const Video = ({ src }: { src: string }) => {
  return (
    <video key={src} className="size-full" controls>
      <source src={src} />
      <track default kind="captions" />
    </video>
  )
}
